import { api } from "./client";

export interface AuditEntry {
  id: number;
  at: string;
  actorType: string;
  userId: number | null;
  unitId: number | null;
  accion: string;
  entidad: string;
  entidadId: number | null;
  ip: string | null;
  outcome: string;
  payloadJson: unknown;
}

export interface AuditPage {
  items: AuditEntry[];
  total: number;
  page: number;
  size: number;
}

export async function searchAudit(params: {
  from?: string;
  to?: string;
  userId?: number;
  unitId?: number;
  accion?: string;
  entidad?: string;
  q?: string;
  page?: number;
  size?: number;
}): Promise<AuditPage> {
  const res = await api.get<AuditPage>("/audit", { params });
  return res.data;
}
